@switch (data?.status) {
  @case ('ACTIVE') {
    <ng-container [ngTemplateOutlet]="box" [ngTemplateOutletContext]="{ status: 'active', tooltip: 'ACTIVE' }" />
  }
  @case ('PENDING') {
    <ng-container
      [ngTemplateOutlet]="box"
      [ngTemplateOutletContext]="{
        status: 'pending',
        tooltip: data?.publishFailed
          ? 'PUBLICATION FAILED'
          : 'PENDING ' +
            (data?.mainContact?.isActivated ? 'PUBLICATION' : 'REGISTRATION') +
            '\n SENT ' +
            (data?.invitationDate | dateepoch: currentUserTimezone) +
            ' - ' +
            (data.invitationDate | time: currentUserTimezone)
      }" />
  }
  @case ('ARCHIVED') {
    <ng-container
      [ngTemplateOutlet]="box"
      [ngTemplateOutletContext]="{
        status: 'archived',
        tooltip:
          'ARCHIVED \n ' +
          (data?.archivedDate | dateepoch: currentUserTimezone) +
          ' - ' +
          (data?.archivedDate | time: currentUserTimezone)
      }" />
  }
  @case ('ENABLED') {
    @if (data?.isActivated) {
      <ng-container [ngTemplateOutlet]="box" [ngTemplateOutletContext]="{ status: 'active', tooltip: 'ENABLED' }" />
    }
    @if (!data?.isActivated) {
      <ng-container [ngTemplateOutlet]="box" [ngTemplateOutletContext]="{ status: 'pending', tooltip: 'INVITED' }" />
    }
  }
  @case ('DISABLED') {
    <ng-container [ngTemplateOutlet]="box" [ngTemplateOutletContext]="{ status: 'pending', tooltip: 'DISABLED' }" />
  }
  @case ('SUSPENDED') {
    <ng-container [ngTemplateOutlet]="box" [ngTemplateOutletContext]="{ status: 'suspended', tooltip: 'SUSPENDED' }" />
  }
  @case ('UNAVAILABLE') {
    <ng-container
      [ngTemplateOutlet]="box"
      [ngTemplateOutletContext]="{
        status: 'unavailable',
        tooltip: unavailabilityTypeEnum[data.unavailabilityType] | uppercase
      }" />
  }
}

<ng-template #box let-status="status" let-tooltip="tooltip">
  <div
    class="status-box"
    [ngClass]="'status-box-' + status"
    [matTooltipClass]="'status-box-' + status"
    [matTooltip]="tooltip"></div>
</ng-template>
